// Share-related constants
export const SHARE_URLS = {
  TWITTER: 'https://twitter.com/intent/tweet?text=',
  LINKEDIN: 'https://www.linkedin.com/sharing/share-offsite/?url=',
  FACEBOOK: 'https://www.facebook.com/sharer/sharer.php?u='
} as const;

// Email template
export const EMAIL_TEMPLATE = {
  GREETING: 'Bonjour,',
  INTRO: 'Je partage avec vous cette cotation NGAP :',
  COTATION_LABEL: 'Cotation :',
  LINK_LABEL: 'Lien :',
  CLOSING: 'Cordialement'
} as const;

// Share colors for different platforms
export const SHARE_COLORS = {
  EMAIL: 'text-gray-600 hover:text-gray-800',
  TWITTER: 'text-blue-400 hover:text-blue-600',
  LINKEDIN: 'text-blue-600 hover:text-blue-800',
  FACEBOOK: 'text-blue-500 hover:text-blue-700',
  COPY_LINK: 'text-gray-600 hover:text-gray-800',
  COPIED: 'text-green-600'
} as const;